<template>
	<TheTable :tableData="filteredActivities" :loading="loading" :defaultSort="{ prop: 'unread', order: 'descending' }" @rowClick="goToDetailPage">
		<el-table-column prop="type" label="Art" width="150" sortable>
			<template #default="scope">
				<span>{{ parseActivityType(scope.row.type) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="title" label="Titel" min-width="150" sortable :sort-method="(a, b) => $sortAlphabetically(a, b, 'title')" />
		<el-table-column prop="event" label="Event" width="150" sortable>
			<template #default="scope">
				<span>{{ parseActivityKey(scope.row.key) }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="createdDate" label="Zeitstempel" width="130" sortable>
			<template #default="scope">
				<span>{{ $formatDate(scope.row.timestamp) }}</span>
			</template>
		</el-table-column>
	</TheTable>
</template>

<script lang="ts">
import { ActivityKey, ActivityResponse, ActivityType } from '@/types/types';
import TheTable from '../TheTable.vue';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
	name: 'LastActivitiesTable',
	data() {
		return {};
	},
	props: {
		activities: {
			type: Array as PropType<ActivityResponse[]>,
			default: () => [],
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		filteredActivities(): ActivityResponse[] {
			return this.filterActivities(this.activities);
		},
	},
	methods: {
		parseActivityType(type: ActivityType) {
			switch (type) {
				case ActivityType.Complaint:
					return 'Beschwerde';
				case ActivityType.Case:
					return 'Fall';
				case ActivityType.Callback:
					return 'Rückfrage';
				case ActivityType.Decision:
					return 'Entscheidung';
				case ActivityType.Statement:
					return 'Stellungnahme';
				default:
					return 'Unbekannt';
			}
		},
		parseActivityKey(key: ActivityKey) {
			switch (key) {
				case ActivityKey.CallbackWithAnswer:
					return 'Rückfrage mit Antwort';
				case ActivityKey.CaseDecided:
					return 'Fall entschieden';
				case ActivityKey.CasePublished:
					return 'Fall veröffentlicht';
				case ActivityKey.ComplaintDecided:
					return 'Beschwerde entschieden';
				case ActivityKey.ComplaintPublished:
					return 'Beschwerde veröffentlicht';
				case ActivityKey.ComplaintWithoutCase:
					return 'Beschwerde ohne Fall';
				case ActivityKey.DecisionWithReason:
					return 'Entscheidung mit Begründung';
				case ActivityKey.StatementExpiredFirstValid:
					return 'Erste gültige Stellungnahme abgelaufen';
				case ActivityKey.StatementExpiredLastValid:
					return 'Letzte gültige Stellungnahme abgelaufen';
				case ActivityKey.StatementWithAnswer:
					return 'Stellungnahme mit Antwort';
				default:
					return 'Unbekannt';
			}
		},
		goToDetailPage(row: ActivityResponse) {
			switch (row.type) {
				case ActivityType.Complaint:
					this.$router.push({ name: 'BeschwerdeDetail', params: { id: String(row.id) } });
					break;
				case ActivityType.Case:
					this.$router.push({ name: 'FallDetail', params: { id: String(row.id) } });
					break;
				case ActivityType.Decision:
					this.$router.push({ name: 'EntscheidungDetail', params: { id: String(row.id) } });
					break;
				case ActivityType.Callback:
					this.$router.push({ name: 'BeschwerdeDetail', params: { id: String(row.complaintId) } });
					break;
				case ActivityType.Statement:
					this.$router.push({ name: 'StellungnahmeDetail', params: { id: String(row.id) } });
					break;
				default:
					break;
			}
		},
		filterActivities(activities: ActivityResponse[]): ActivityResponse[] {
			return activities.filter((activity) => activity.type !== ActivityType.Decision);
		},
	},
	components: {
		TheTable,
	},
});
</script>

<style lang="scss"></style>
